<div
  class="login-wrapper"
  [style.background-image]="'url(' + branding.loginBackground + ')'"
  [style.background-position]="branding.loginBackgroundPosition"
  [style.background-size]="branding.loginBackgroundSize"
  *transloco="let t; prefix: 'login'">
  <form class="login" [formGroup]="loginForm">
    <div class="login-header">
      <div class="logo">
        <img width="33%" [src]="branding.logoLogin" [alt]="branding.appTitle" />
      </div>
      <div class="actions">
        <clr-dropdown>
          <button class="btn btn-link btn-sm" clrDropdownTrigger>
            {{ t('language') }}
            <cds-icon shape="angle" direction="down"></cds-icon>
          </button>
          <clr-dropdown-menu>
            <div aria-label="Language 1" (click)="changeLanguage('de')" clrDropdownItem>Deutsch</div>
            <div aria-label="Language 2" (click)="changeLanguage('en')" clrDropdownItem>English</div>
            <div aria-label="Language 3" (click)="changeLanguage('jp')" clrDropdownItem>日本語</div>
          </clr-dropdown-menu>
        </clr-dropdown>
      </div>
    </div>
    <div class="login-body">
      <section class="title">
        <div class="welcome">{{ t('welcome') }} {{ currentLang }}</div>
        {{ branding.appTitle }}
        <div class="hint">{{ t('pleaseLogin')}}</div>
        <span class="p7">V {{ ppsversion }}</span>
        <span *ngIf="devMode" class="p7"> ({{stage}})</span>
      </section>

      <div class="login-group">
        <clr-input-container>
          <label class="clr-sr-only">{{ t('username') }}</label>
          <input
            class="form-control"
            formControlName="username"
            type="text"
            autocomplete="username"
            name="username"
            clrInput
            placeholder="Username"
            required
          />
        </clr-input-container>
        <clr-password-container>
          <label class="clr-sr-only">Password</label>
          <input
            class="form-control"
            formControlName="password"
            type="password"
            autocomplete="current-password"
            name="password"
            clrPassword
            placeholder="Enter password"

          />
        </clr-password-container>
        <div *ngIf="errorStatus" class="error active">Invalid user name or password</div>
        <button *ngIf="!loading" (click)="loginUser()" type="submit" class="btn btn-primary">{{ t('login') }}</button>
        <button *ngIf="loading" class="btn btn-primary"><clr-spinner clrInline></clr-spinner> {{ t('stayTuned') }}</button>
      </div>

      <clr-alert *ngIf="devMode && authDebugReason" [clrAlertType]="'warning'" [clrAlertClosable]="false" class="auth-debug-alert">
        <clr-alert-item>
          <span class="alert-text auth-debug-alert__content">
            <span class="auth-debug-alert__header">
              <strong>Dev Login Redirect</strong>
              <button type="button" class="btn btn-sm btn-link" (click)="dismissAuthDebugReason()">schließen</button>
            </span>
            <span class="auth-debug-alert__row"><span>Grund:</span> {{ authDebugReason.reason }}</span>
            <span class="auth-debug-alert__row"><span>Meldung:</span> {{ authDebugReason.message }}</span>
            <span class="auth-debug-alert__row"><span>Zeit:</span> {{ authDebugReason.at | date: 'dd.MM.yyyy HH:mm:ss' }}</span>
            <pre *ngIf="authDebugReason.details" class="auth-debug-alert__details">{{ authDebugReason.details | json }}</pre>
          </span>
        </clr-alert-item>
      </clr-alert>

      <section class="title">
        <div class="hint">System-Check</div>
        <div class="sys-check" style="margin-top:24px">
          <ul class="sys-check__list">
            <li class="sys-check__item" *ngFor="let check of healthChecks">
              <cds-icon
                class="sys-check__icon"
                [attr.shape]="iconShape(check.status)"
                [ngClass]="'status-' + check.status"
                aria-hidden="true">
              </cds-icon>

              <span class="sys-check__label">{{ check.label }}</span>
              <span *ngIf="check.note" class="sys-check__note">{{ check.note }}</span>
            </li>
          </ul>
        </div>
        <div class="hint"><br>{{ t('passion') }}</div>
      </section>
    </div>
    <div class="login-footer">
      <span class="copyright">
        Copyright © 2020-2026 All Rights Reserved.
      </span>
    </div>
  </form>
</div>
